const DEV_COMPETITION_API_BASE = "https://g9hxezj75g.execute-api.us-east-2.amazonaws.com";
const PROD_COMPETITION_API_BASE = "https://jbkvplm39b.execute-api.us-east-1.amazonaws.com";

function trimTrailingSlash(value) {
  return String(value || "").trim().replace(/\/$/, "");
}

const explicitBase = trimTrailingSlash(process.env.REACT_APP_LEADERBOARD_API_BASE);
const isProductionBuild = process.env.NODE_ENV === "production";
const fallbackBase = isProductionBuild ? PROD_COMPETITION_API_BASE : DEV_COMPETITION_API_BASE;

export const COMPETITION_API_BASE = explicitBase || fallbackBase;

// Tournament v2 is deployed to dev first. Production requires an explicit rollout.
export function isTournamentV2Enabled() {
  return process.env.REACT_APP_TOURNAMENT_V2_ENABLED === "true" || COMPETITION_API_BASE === DEV_COMPETITION_API_BASE;
}

export function getCompetitionApiEnvironment() {
  const base = COMPETITION_API_BASE;
  const isDev = base === DEV_COMPETITION_API_BASE || /execute-api\.us-east-2\.amazonaws\.com/.test(base);
  const isProd = base === PROD_COMPETITION_API_BASE || /execute-api\.us-east-1\.amazonaws\.com/.test(base);

  return {
    base,
    label: isDev ? "Dev API" : isProd ? "Production API" : "Custom API",
    source: explicitBase ? "env" : "default",
    shouldShowIndicator: !isProductionBuild || !isProd
  };
}
